import Api from "~/service/Api";

class MediaItemBulkUpdateRepository {
  update(tourId, data) {
    return Api.put(`/media-items/bulk-update/${tourId}`, data);
  }
}

export default MediaItemBulkUpdateRepository;
